import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import api from "../../../services/api";
import { isAdmin } from "../../../services/auth";

import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Motorista/style.scss";
import { MdDeleteForever } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";

import Swal from "sweetalert2";
import { CiEdit } from "react-icons/ci";
import { getTipoLabel } from "../../Motorista/TipoMotorista";
import { useNavigate } from "react-router-dom";
import Preloader from "../../PreloaderGrids/Preloader";
import { pdf } from "@react-pdf/renderer";
import BaseTemplate from "../../Reports/GeradorPDF/BasePDFTemplate";
import { FiFileText } from "react-icons/fi";
import { FiTruck } from "react-icons/fi";
import logo from "../../../assets/logo.png"




function Cadastro() {
  const [marcadores, setMarcadores] = useState([]);
  const [marc, setMot] = useState([]);
  const [item, setItem] = useState([]);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [mediaPage, setMediaPage] = useState(2);
  const [limit, setLimit] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const tipo = localStorage.getItem("tipo");
  const colorPagination = "#dee2e6";
  const [totalItems, setTotalItems] = useState(0);
  const [selecionados, setSelecionados] = useState([]);
  // const [selectedIds, setSelectedIds] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);





  //NAVEGAÇÃO 
  const navigate = useNavigate();

  const toggleSelecionado = (id) => {
    setSelecionados((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  }









  const confirmarPDF = async () => {
    // =========================================================
    // VALIDAR REGISTROS
    // =========================================================

    if (!marcadores || marcadores.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhum registro",
        text: "Não há motoristas para gerar o PDF.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#f59e0b",
      });

      return;
    }

    // =========================================================
    // MOTORISTAS QUE SERÃO ENVIADOS PARA O PDF
    // =========================================================

    const motoristasPDF = marcadores;

    console.log("=================================");
    console.log("GERAÇÃO DE PDF - MOTORISTAS");
    console.log("Motoristas:", motoristasPDF);
    console.log("Quantidade:", motoristasPDF.length);
    console.log("=================================");

    // =========================================================
    // CONFIRMAÇÃO
    // =========================================================

    const result = await Swal.fire({
      html: `
      <div class="swal-pdf-content">

        <div class="swal-pdf-question">
          ?
        </div>

        <div class="swal-pdf-heading">
          Gerar PDF?
        </div>

        <p class="swal-pdf-subtitle">
          Você está prestes a gerar um relatório com:
        </p>

        <div class="swal-pdf-count">
          ${motoristasPDF.length}
        </div>

        <div class="swal-pdf-label">
          motorista(s)
        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Sim, gerar",
      cancelButtonText: "Cancelar",

      reverseButtons: true,

      buttonsStyling: false,

      customClass: {
        popup: "swal-pdf-popup",
        htmlContainer: "swal-pdf-html",
        actions: "swal-pdf-actions",
        confirmButton: "swal-pdf-confirm",
        cancelButton: "swal-pdf-cancel",
      },
    });

    // =========================================================
    // CANCELADO
    // =========================================================

    if (!result.isConfirmed) {
      return;
    }

    // =========================================================
    // TOKEN
    // =========================================================

    const token = localStorage.getItem("id");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Cliente não identificado",
        text: "Não foi possível identificar o cliente.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#ef4444",
      });

      return;
    }

    // =========================================================
    // ABRIR NOVA ABA
    // =========================================================

    const novaAba = window.open("", "_blank");

    if (!novaAba) {
      Swal.fire({
        icon: "warning",
        title: "Nova aba bloqueada",
        text: "Permita pop-ups para visualizar o relatório.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#f59e0b",
      });

      return;
    }

    // =========================================================
    // LOADING DENTRO DA NOVA ABA
    // =========================================================

    novaAba.document.write(`
    <!DOCTYPE html>

    <html lang="pt-BR">

    <head>

      <meta charset="UTF-8">

      <title>
        Gerando relatório...
      </title>

      <style>

        * {
          box-sizing: border-box;
        }

        html,
        body {
          margin: 0;
          width: 100%;
          height: 100%;

          font-family:
            Arial,
            Helvetica,
            sans-serif;

          background: #0b1220;
        }

        body {
          display: flex;

          align-items: center;
          justify-content: center;
        }

        .loading-container {

          width: 380px;

          padding: 42px 35px;

          text-align: center;

          border-radius: 18px;

          background:
            linear-gradient(
              145deg,
              #111c2d,
              #0d1726
            );

          border:
            1px solid
            rgba(255,255,255,.08);

          box-shadow:
            0 25px 70px
            rgba(0,0,0,.45);
        }

        .spinner {

          width: 48px;
          height: 48px;

          margin: 0 auto 25px;

          border-radius: 50%;

          border:
            3px solid
            rgba(255,255,255,.10);

          border-top-color:
            #0b73b5;

          animation:
            spin .8s linear infinite;
        }

        @keyframes spin {

          to {
            transform:
              rotate(360deg);
          }

        }

        .title {

          font-size: 20px;

          font-weight: 700;

          color: #ffffff;

          margin-bottom: 8px;
        }

        .text {

          font-size: 13px;

          color: #94a3b8;

          line-height: 1.5;
        }

        .brand {

          margin-top: 25px;

          font-size: 10px;

          color: #4d87ad;

          letter-spacing: 1.2px;

          text-transform: uppercase;
        }

      </style>

    </head>

    <body>

      <div class="loading-container">

        <div class="spinner"></div>

        <div class="title">
          Gerando relatório
        </div>

        <div class="text">
          Estamos preparando seu PDF.<br>
          Isso pode levar alguns segundos...
        </div>

        <div class="brand">
          Relatório de Motoristas
        </div>

      </div>

    </body>

    </html>
  `);

    novaAba.document.close();

    // =========================================================
    // FORM POST
    // =========================================================

    const form =
      novaAba.document.createElement("form");

    form.method = "POST";

    form.action =
      `${api.defaults.baseURL}/motoristaPDF`;

    form.style.display = "none";

    // =========================================================
    // TOKEN
    // =========================================================

    const inputToken =
      novaAba.document.createElement("input");

    inputToken.type = "hidden";

    inputToken.name = "token";

    inputToken.value = token;

    form.appendChild(inputToken);

    // =========================================================
    // MOTORISTAS DA PÁGINA ATUAL
    // =========================================================

    const inputMotoristas =
      novaAba.document.createElement("input");

    inputMotoristas.type = "hidden";

    inputMotoristas.name = "motoristas";

    inputMotoristas.value =
      JSON.stringify(motoristasPDF);

    form.appendChild(inputMotoristas);

    // =========================================================
    // QUANTIDADE
    // =========================================================

    const inputQuantidade =
      novaAba.document.createElement("input");

    inputQuantidade.type = "hidden";

    inputQuantidade.name = "quantidade";

    inputQuantidade.value =
      motoristasPDF.length;

    form.appendChild(inputQuantidade);

    // =========================================================
    // DEBUG
    // =========================================================

    console.log("=================================");
    console.log("POST /motoristaPDF");
    console.log("Token:", token);
    console.log("Quantidade:", motoristasPDF.length);
    console.log("Motoristas enviados:", motoristasPDF);
    console.log(
      "JSON:",
      JSON.stringify(motoristasPDF)
    );
    console.log("=================================");

    // =========================================================
    // ADICIONAR FORM NA NOVA ABA
    // =========================================================

    novaAba.document.body.appendChild(form);

    // =========================================================
    // ENVIAR
    // =========================================================

    form.submit();

    // =========================================================
    // LOADING NO SISTEMA
    // =========================================================

    Swal.fire({
      html: `
      <div class="swal-pdf-loading">

        <div class="swal-pdf-loading-spinner"></div>

        <div class="swal-pdf-loading-title">
          Gerando PDF
        </div>

        <div class="swal-pdf-loading-text">
          Preparando seu relatório...
        </div>

      </div>
    `,

      allowOutsideClick: false,
      allowEscapeKey: false,

      showConfirmButton: false,

      timer: 900,

      customClass: {
        popup: "swal-pdf-loading-popup",
        htmlContainer: "swal-pdf-loading-html",
      },
    });
  };




  //EDITAR MOTORISTA

  const handleEditar = async (marcador) => {
    const result = await Swal.fire({
      width: "560px",
      padding: "0",

      background: "#0b1424",
      color: "#e5eef7",

      html: `
      <div class="editar-motorista-modal">

        <!-- HEADER -->
        <div class="editar-motorista-header">

          <div class="editar-motorista-icon">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
            </svg>
          </div>

          <div class="editar-motorista-title">
            <h2>Editar motorista</h2>
            <span>Confirme os dados antes de continuar</span>
          </div>

        </div>

        <!-- DADOS -->
        <div class="editar-motorista-info">

          <div class="editar-motorista-item editar-motorista-full">
            <span>Nome completo</span>
            <strong>${marcador.nome || "Não informado"}</strong>
          </div>

          <div class="editar-motorista-item">
            <span>CPF</span>
            <strong>${marcador.cpf || "Não informado"}</strong>
          </div>

          <div class="editar-motorista-item">
            <span>Tipo</span>
            <strong>${getTipoLabel(marcador.tipo) || "Não informado"}</strong>
          </div>

          <div class="editar-motorista-item">
            <span>Categoria CNH</span>
            <strong>${marcador.categoria || "Não informado"}</strong>
          </div>

          <div class="editar-motorista-item">
            <span>Número do acesso</span>
            <strong>${marcador.num_cartao_acesso || marcador.access_code || "Não informado"}</strong>
          </div>

        </div>

        <!-- AVISO -->
        <div class="editar-motorista-warning">

          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>

          <span>
            Os dados serão carregados para edição.
          </span>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: `
      <span class="editar-btn-content">
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 20h9"/>
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
        </svg>
        Editar motorista
      </span>
    `,

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      buttonsStyling: true,

      customClass: {
        popup: "swal-editar-motorista",
        confirmButton: "swal-editar-confirm",
        cancelButton: "swal-editar-cancel",
        actions: "swal-editar-actions"
      }
    });

    if (!result.isConfirmed) return;

    /* ============================================
       LOADER
    ============================================ */

    Swal.fire({
      width: "420px",
      padding: "32px",

      background: "#0b1424",
      color: "#ffffff",

      title: "Abrindo edição...",

      html: `
      <div class="editar-loader">

        <div class="editar-loader-text">
          Carregando dados do motorista
        </div>

        <div class="editar-loader-spinner"></div>

        <div class="editar-loader-subtext">
          Aguarde um momento...
        </div>

      </div>
    `,

      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,

      scrollbarPadding: false,

      customClass: {
        popup: "swal-loader-motorista"
      }
    });

    /* ============================================
       REDIRECIONAMENTO
    ============================================ */

    setTimeout(() => {
      Swal.close();

      navigate("/maps/editar-motorista", {
        state: {
          motorista: marcador
        }
      });
    }, 900);
  };



  const handleSelecionadas = (valor1) => {
    setLimit(valor1);
  };
  const [isAdminState, setIsAdminState] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const response = await isAdmin();
      if (response.status === "success" && response.isAdmin) {
        setIsAdminState(true);
      } else {
        setIsAdminState(false);
      }
    };

    checkAdmin();
  }, []);
  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/motoristaPDF");
      setMot(data);
      console.log(data);
    }
    fetchData();
  }, []);

  //DADOS POR PAGINA
  //DELAY POR PAGINA


  //====================
  //INTENS POR PÁGINA
  //====================
  useEffect(() => {
    let mounted = true

    async function fetchData() {

      const start = Date.now();

      const MIN_DELAY = 2500; // 2.5 segundos mínimos

      try {

        // Ativa loading da paginação
        setLoadingPage(true);

        const { data } = await api.get(
          `/motoristapages?limit=${limit}&page=${currentPage}&searchTerm=${searchTerm}`,
          {
            headers: {
              typo: localStorage.getItem("id"),
            },
          }
        );

        // Atualiza dados apenas se componente estiver montado
        if (mounted) {

          const motoristas = Array.isArray(data?.motoristas?.data)
            ? data.motoristas.data
            : [];

          setMarcadores(motoristas);
        }

      } catch (error) {

        // Em caso de erro limpa dados
        if (mounted) {
          setMarcadores([]);
        }

        console.error("Erro ao buscar motoristas:", error);

      } finally {


        // Calcula duração da requisição
        const elapsed = Date.now() - start;

        // Mantém loading mínimo para evitar flickering
        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed);
        }

        // Finaliza loading suavemente
        if (mounted) {
          setLoadingPage(false);
        }
      }
    }

    fetchData();

    return () => {
      mounted = false;
    };

  }, [currentPage, limit, searchTerm]);





  // Busca total de registros e monta paginação
  useEffect(() => {

    async function fetchTotalPages() {

      try {

        // Busca total de motoristas filtrados
        const { data } = await api.get(
          `/totalmotorista?searchTerm=${searchTerm}`,
          {
            headers: {
              typo: localStorage.getItem("id"),
            },
          }
        );

        // Total retornado pela API
        const total = Number(data?.result) || 0;

        setTotalItems(total);

        // Calcula total de páginas
        const totalPages = Math.ceil(total / limit);

        // Cria array das páginas
        // Exemplo: [1,2,3,4]
        const arrayPages = Array.from(
          { length: totalPages },
          (_, i) => i + 1
        );

        setPages(arrayPages);

        // Garante que página atual não ultrapasse limite
        if (currentPage > totalPages) {

          setCurrentPage(1);

          setMediaPage(2);
        }

      } catch (error) {

        console.error(
          "Erro ao buscar total de motoristas:",
          error
        );
      }
    }

    fetchTotalPages();

  }, [limit, searchTerm]);



  // PAGINAÇÃO
  const handlePagination = (page) => {
    if (page >= 1 && page <= pages.length) {
      setLoadingPage(true);
      setCurrentPage(page);

      if (page === 1) {
        setMediaPage(2);
      } else if (page === pages.length) {
        setMediaPage(page - 1);
      } else {
        setMediaPage(page);
      }
    }
  };

  //LIMITES POR PAGINA
  const limits = useCallback((e) => {
    const newLimit = parseInt(e.target.value, 10);
    setLoadingPage(true)
    setLimit(newLimit);
    setCurrentPage(1);
    setMediaPage(2);
  }, []);




  //===============================
  // PRELOADER PRINCIPAL
  //===============================

  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  // Busca dados paginados com loader inicial animado







  async function fetchDataCache(limit, currentPage) {

    // Exibe loader inicial
    setLoading(true);

    const start = Date.now();

    try {

      const { data } = await api.get(
        `/motoristapages?limit=${limit}&page=${currentPage}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
          },
        }
      );

      const motoristas = Array.isArray(data?.motoristas?.data)
        ? data.motoristas.data
        : [];

      setMarcadores(motoristas);

    } catch (error) {

      console.error(
        "Erro ao buscar dados com cache:",
        error
      );

      setMarcadores([]);

    } finally {

      const elapsed = Date.now() - start;

      const minDelay = 5000;

      if (elapsed < minDelay) {
        await delay(minDelay - elapsed);
      }

      // Finaliza loader
      setLoading(false);

      // Fade-out
      await delay(1000);

      // Remove loader
      setShowLoader(false);
    }
  }

  useEffect(() => {

    fetchDataCache(limit, currentPage);

  }, [currentPage]);






  function getVisiblePages(currentPage, totalPages) {
    const pages = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, "...", totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, "...", totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }

    return pages;
  }



  const selecionadosInfo = marcadores
    .filter((m) => selecionados.includes(m.id))
    .map((m) => {
      const tipo =
        m.tipo === "m"
          ? "Motorista"
          : m.tipo === "a"
            ? "Acompanhante"
            : "—";

      return `  <div style="
            border:1px solid #052943;
            border-radius:8px;
            padding:10px;
            margin-bottom:10px;
            background:none;
             text-align:left;
          ">
          
      <p  ><b style="color:#70BEFD;">Nome:</b> ${m.nome}</p>
      <p ><b style="color:#70BEFD;">CPF: </b>${m.cpf}</p>
      <p ><b style="color:#70BEFD;">Tipo:</b> ${getTipoLabel(m.tipo)}</p>
      <p ><b style="color:#70BEFD;">Categoria CNH:</b> ${m.categoria || `Não possui CNH`}</p>
         </div>
    `;
    })
    .join("");


  //CONFIRMAÇÃO PARA EXCLUIR 
  const handleExcluirSelecionados = async () => {
    const result = await Swal.fire({
      width: "560px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
      <div class="excluir-motoristas-modal">

        <!-- HEADER -->
        <div class="excluir-motoristas-header">

          <div class="excluir-motoristas-icon">

            <svg
              width="23"
              height="23"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6l-1 14H6L5 6"/>
              <path d="M10 11v6"/>
              <path d="M14 11v6"/>
              <path d="M9 6V4h6v2"/>
            </svg>

          </div>

          <div>

            <h2>
              Confirmar exclusão
            </h2>

            <span>
              Revise os motoristas antes de continuar
            </span>

          </div>

        </div>


        <!-- CONTEÚDO -->
        <div class="excluir-motoristas-content">

          <div class="excluir-motoristas-text">

            Você está prestes a excluir

            <strong>
              ${selecionados.length}
            </strong>

            motorista(s).

          </div>


          <!-- LISTA -->
          <div class="excluir-motoristas-box">

            <div class="excluir-motoristas-label">
              Motoristas selecionados
            </div>

            <div class="excluir-motoristas-lista">
              <ul>
                ${selecionadosInfo}
              </ul>
            </div>

          </div>


          <!-- AVISO -->
          <div class="excluir-motoristas-aviso">

            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

            <span>
              Essa ação poderá ser revertida futuramente.
            </span>

          </div>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Excluir motoristas",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      customClass: {
        popup: "swal-excluir-motoristas",
        actions: "swal-excluir-motoristas-actions",
        confirmButton: "swal-excluir-motoristas-confirm",
        cancelButton: "swal-excluir-motoristas-cancel"
      }
    });

    if (!result.isConfirmed) return;


    /* ============================================================
       LOADER
    ============================================================ */

    try {

      await Swal.fire({

        width: "420px",
        padding: "0",

        background: "#0f172a",
        color: "#ffffff",

        html: `
        <div class="excluir-loader">

          <div class="excluir-loader-icon">

            <div class="excluir-loader-spinner"></div>

          </div>

          <h2>
            Excluindo motoristas...
          </h2>

          <span>
            Processando exclusão...
          </span>

        </div>
      `,

        showConfirmButton: false,

        allowOutsideClick: false,
        allowEscapeKey: false,

        customClass: {
          popup: "swal-excluir-loader"
        },

        didOpen: async () => {

          try {

            await Promise.all(

              selecionados.map((id) =>
                api.put(`/motoristas/${id}`, {
                  ativo: false,
                  awsd: Cookies.get("2353138890"),
                  apagado_por: localStorage.getItem("clientID"),
                })
              )

            );


            Swal.close();


            /* ====================================================
               SUCESSO
            ==================================================== */

            await Swal.fire({

              width: "420px",
              padding: "0",

              background: "#0f172a",
              color: "#ffffff",

              html: `
              <div class="exclusao-sucesso">

                <div class="exclusao-sucesso-icon">

                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M20 6 9 17l-5-5"/>
                  </svg>

                </div>

                <h2>
                  Exclusão concluída
                </h2>

                <p>
                  Os motoristas selecionados foram excluídos com sucesso.
                </p>

              </div>
            `,

              timer: 1800,
              timerProgressBar: true,

              showConfirmButton: false,

              customClass: {
                popup: "swal-exclusao-sucesso"
              }

            });


            /* ====================================================
               LIMPA SELEÇÃO
            ==================================================== */

            setSelecionados([]);


            /* ====================================================
               ATUALIZA TOTAL
            ==================================================== */

            const { data } = await api.get(
              `/totalmotorista?searchTerm=${searchTerm}`,
              {
                headers: {
                  typo: localStorage.getItem("id"),
                },
              }
            );


            const total = data.result;

            setTotalItems(total);


            /* ====================================================
               RECALCULA PÁGINAS
            ==================================================== */

            const totalPages = Math.ceil(total / limit);


            setPages(
              Array.from(
                {
                  length: totalPages
                },
                (_, i) => i + 1
              )
            );


            /* ====================================================
               AJUSTA PÁGINA ATUAL
            ==================================================== */

            let newPage =
              currentPage > totalPages
                ? totalPages
                : currentPage;


            if (newPage < 1) {
              newPage = 1;
            }


            setCurrentPage(newPage);

            setMediaPage(
              newPage <= 2
                ? 2
                : newPage
            );


            /* ====================================================
               RECARREGA DADOS
            ==================================================== */

            await fetchDataCache(
              limit,
              newPage
            );

          } catch (error) {

            Swal.close();

            await Swal.fire({

              width: "420px",
              padding: "0",

              background: "#0f172a",
              color: "#ffffff",

              html: `
              <div class="exclusao-erro">

                <div class="exclusao-erro-icon">

                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>

                </div>

                <h2>
                  Erro ao excluir
                </h2>

                <p>
                  Não foi possível excluir os motoristas selecionados.
                  Tente novamente.
                </p>

              </div>
            `,

              confirmButtonText: "Entendi",

              confirmButtonColor: "#dc2626",

              customClass: {
                popup: "swal-exclusao-erro"
              }

            });

          }

        }

      });

    } catch (error) {

      await Swal.fire({

        width: "420px",
        padding: "0",

        background: "#0f172a",
        color: "#ffffff",

        html: `
        <div class="exclusao-erro">

          <div class="exclusao-erro-icon">

            <svg
              width="25"
              height="25"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

          </div>

          <h2>
            Erro
          </h2>

          <p>
            Erro ao excluir motoristas selecionados.
          </p>

        </div>
      `,

        confirmButtonText: "Entendi",

        confirmButtonColor: "#dc2626",

        customClass: {
          popup: "swal-exclusao-erro"
        }

      });

    }
  };





  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = marcadores.map((m) => m.id);
      setSelecionados(allIds);
    } else {
      setSelecionados([]);
    }
  };
  const handleDeleteSelected = async () => {
    if (window.confirm(`Tem certeza que deseja excluir ${selecionados.length} motorista(s)?`)) {
      try {
        await Promise.all(
          selecionados.map(async (id) => {
            await api.put(`/motoristas/${id}`, {
              ativo: id,
              awsd: Cookies.get("2353138890"),
            });
          })
        );

        toast.success("Motoristas excluídos com sucesso");

        setSelecionados([]);

        // Atualiza os dados após exclusão
        const { data } = await api.get(`/totalmotorista?searchTerm=${searchTerm}`, {
          headers: {
            typo: localStorage.getItem("id"),
          },
        });

        const total = data.result;
        setTotalItems(total);

        const totalPages = Math.ceil(total / limit);
        const arrayPages = Array.from({ length: totalPages }, (_, i) => i + 1);
        setPages(arrayPages);

        let newPage = currentPage > totalPages ? totalPages : currentPage;
        if (newPage < 1) newPage = 1;

        setCurrentPage(newPage);
        setMediaPage(newPage <= 2 ? 2 : newPage);

        await fetchDataCache(limit, newPage);
      } catch (error) {
        toast.error("Erro ao excluir motoristas");
      }
    }
  };

  //COLUNAS TABELEA
  const columns = [
    { label: "Nome", width: "auto" },
    { label: "CPF", width: "auto", align: "center" },
    { label: "Apelido", width: "auto" },
    { label: "Tipo", width: "auto", align: "center" },
    { label: "Número CNH", width: "auto", align: "center" },
    { label: "Número do cartão", width: "auto", align: "center" },
    { label: "CNPJ", width: "auto", align: "center" },
    { label: "Categoria", width: "auto", align: "center" },
    { label: "PIS", width: "auto", align: "center" },
  ];

  //ESTILO COLUNAS TABELA
  const thBaseStyle = {
    textTransform: "uppercase",
    fontSize: "10pt",
    letterSpacing: "1px",
  };




  return (
    <>
      <ToastContainer />

      <div
        className="motoristas-page"
        style={{ paddingTop: 0, minHeight: 0 }}
      >
        <section className="motoristas-ui-panel">
          <Preloader
            show={loading}
            text="Carregando dados dos motoristas..."
            customClass="preloader-motorista"
          />

          {/* CABEÇALHO */}
          <header className="motoristas-ui-header">
            <div className="motoristas-ui-heading">
              <span className="motoristas-ui-heading-icon">
                <FiTruck size={18} />
              </span>

              <div className="motoristas-ui-heading-text">
                <h1 className="motoristas-ui-title">Motoristas</h1>

                <p className="motoristas-ui-subtitle">
                  Gerencie os motoristas cadastrados e seus acessos
                </p>
              </div>
            </div>

            <button
              type="button"
              className="motoristas-ui-close"
              onClick={() => navigate("/maps")}
              aria-label="Fechar motoristas"
              title="Fechar"
            >
              ✕
            </button>
          </header>

          {/* PESQUISA E AÇÕES */}
          <div className="motoristas-ui-toolbar">
            <label
              className="motoristas-ui-search"
              htmlFor="motoristas-search"
            >
              <svg
                width="17"
                height="17"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="m16 16 4 4" />
              </svg>

              <input
                id="motoristas-search"
                type="search"
                placeholder="Buscar motorista, CPF ou nome..."
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                autoComplete="off"
                aria-label="Buscar motoristas"
              />

              {searchTerm && (
                <button
                  type="button"
                  className="motoristas-ui-search-clear"
                  onClick={() => setSearchTerm("")}
                  aria-label="Limpar pesquisa"
                  title="Limpar pesquisa"
                >
                  ✕
                </button>
              )}
            </label>

            {isAdminState && (
              <div className="motoristas-ui-toolbar-actions">
                <button
                  type="button"
                  onClick={confirmarPDF}
                  className="motoristas-ui-action"
                >
                  <FiFileText size={16} />
                  <span>Gerar PDF</span>
                </button>

                <Link
                  to="/maps/cadastro-motorista"
                  className="motoristas-ui-action motoristas-ui-action-primary"
                >
                  <span className="motoristas-ui-plus">+</span>
                  <span>Novo motorista</span>
                </Link>
              </div>
            )}
          </div>

          {/* TABELA */}
          <div className="motoristas-ui-table-container">
            <img src={logo} className="logo"></img>
            <div className="motoristas-ui-table-scroll">
              <table className="motoristas-ui-table">
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th
                        key={col.label}
                        scope="col"
                        style={{
                          width: col.width,
                          maxWidth: col.width,
                          textAlign: col.align || "left",
                        }}
                      >
                        {col.label}
                      </th>
                    ))}

                    {isAdminState && (
                      <th
                        scope="col"
                        style={{ textAlign: "center" }}
                      >
                        <label
                          className="custom-checkbox"
                          title="Selecionar todos"
                        >
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            checked={
                              marcadores.length > 0 &&
                              selecionados.length === marcadores.length
                            }
                            ref={(input) => {
                              if (input) {
                                input.indeterminate =
                                  selecionados.length > 0 &&
                                  selecionados.length < marcadores.length;
                              }
                            }}
                            aria-label="Selecionar todos os motoristas desta página"
                          />
                          <span className="checkmark" />
                        </label>
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {marcadores.map((marcador) => (
                    <tr key={marcador.id}>
                      <td>
                        <span>
                          {String(marcador.nome || "—").toUpperCase()}
                        </span>
                      </td>

                      <td
                        className={
                          !marcador.cpf ? "campo-vazio" : ""
                        }
                      >
                        {marcador.cpf || "Não informado"}
                      </td>

                      <td
                        className={
                          !marcador.apelido ? "campo-vazio" : ""
                        }
                      >
                        {marcador.apelido || "Sem Apelido..."}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {getTipoLabel(marcador.tipo)}
                      </td>

                      <td
                        style={{ textAlign: "center" }}
                        className={
                          !marcador.num_cnh ? "campo-vazio" : ""
                        }
                      >
                        {marcador.num_cnh || "N/A"}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {marcador.num_cartao_acesso || "—"}
                      </td>

                      <td
                        className={
                          !marcador.cnpj ? "campo-vazio" : ""
                        }
                      >
                        {marcador.cnpj || "S/CNPJ"}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {marcador.categoria || "N/A"}
                      </td>

                      <td
                        className={
                          !marcador.num_pis ? "campo-vazio" : ""
                        }
                      >
                        {marcador.num_pis || "S/PIS"}
                      </td>

                      {isAdminState && (
                        <td>
                          <div className="motoristas-ui-row-actions">
                            <Tooltip
                              title="Editar motorista"
                              arrow
                              placement="bottom"
                            >
                              <button
                                type="button"
                                className="motoristas-ui-edit-icon"
                                onClick={() => handleEditar(marcador)}
                                aria-label={`Editar ${marcador.nome || "motorista"}`}
                              >
                                <CiEdit size={22} />
                              </button>
                            </Tooltip>

                            <label
                              className="custom-checkbox"
                              title="Selecionar motorista"
                            >
                              <input
                                type="checkbox"
                                checked={selecionados.includes(marcador.id)}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setSelecionados((prev) =>
                                      prev.includes(marcador.id)
                                        ? prev
                                        : [...prev, marcador.id]
                                    );
                                  } else {
                                    setSelecionados((prev) =>
                                      prev.filter(
                                        (id) => id !== marcador.id
                                      )
                                    );
                                  }
                                }}
                                aria-label={`Selecionar ${marcador.nome || "motorista"}`}
                              />

                              <span className="checkmark" />
                            </label>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}

                  {!loadingPage && marcadores.length === 0 && (
                    <tr>
                      <td
                        colSpan={isAdminState ? columns.length + 1 : columns.length}
                      >
                        <div className="motoristas-ui-empty">
                          <FiTruck size={25} />

                          <strong>
                            {searchTerm.trim()
                              ? "Nenhum resultado encontrado"
                              : "Nenhum motorista cadastrado"}
                          </strong>

                          <span>
                            {searchTerm.trim()
                              ? "Tente outro termo ou limpe a pesquisa."
                              : "Quando houver motoristas cadastrados, eles aparecerão aqui."}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* SELEÇÃO EM LOTE — ANTES DO RODAPÉ */}

          {/* SELEÇÃO EM LOTE — MOTORISTAS */}
          {isAdminState && selecionados.length > 0 && (
            <div className="motoristas-ui-selected">
              <span>
                {selecionados.length}{" "}
                {selecionados.length === 1
                  ? "motorista selecionado"
                  : "motoristas selecionados"}
              </span>

              <button
                type="button"
                className="motoristas-ui-delete-selected"
                onClick={handleExcluirSelecionados}
                title="Excluir motoristas selecionados"
              >
                <MdDeleteForever size={17} />
                <span>Excluir selecionados</span>
              </button>
            </div>
          )}


          {/* RODAPÉ E PAGINAÇÃO */}
          <footer className="motoristas-ui-footer">
            <div className="motoristas-ui-summary">
              <span>
                <strong>{totalItems}</strong>{" "}
                {totalItems === 1 ? "motorista" : "motoristas"}
              </span>

              <span className="motoristas-ui-divider" />

              <span>
                Página{" "}
                <strong>{pages.length ? currentPage : 0}</strong>{" "}
                de <strong>{pages.length}</strong>
              </span>
            </div>

            <nav
              className="motoristas-ui-pagination"
              aria-label="Paginação dos motoristas"
            >
              <button
                type="button"
                className="motoristas-ui-page-button"
                onClick={() => handlePagination(currentPage - 1)}
                disabled={currentPage <= 1 || loadingPage}
                aria-label="Página anterior"
              >
                ‹
              </button>

              {getVisiblePages(currentPage, pages.length).map(
                (page, index) => (
                  <React.Fragment key={`${page}-${index}`}>
                    {page === "..." ? (
                      <span className="motoristas-ui-page-dots">
                        …
                      </span>
                    ) : (
                      <button
                        type="button"
                        className={`motoristas-ui-page-button ${page === currentPage ? "active" : ""
                          }`}
                        onClick={() => handlePagination(page)}
                        disabled={loadingPage}
                        aria-current={
                          page === currentPage ? "page" : undefined
                        }
                      >
                        {page}
                      </button>
                    )}
                  </React.Fragment>
                )
              )}

              <button
                type="button"
                className="motoristas-ui-page-button"
                onClick={() => handlePagination(currentPage + 1)}
                disabled={
                  currentPage >= pages.length || loadingPage
                }
                aria-label="Próxima página"
              >
                ›
              </button>
            </nav>

            <label className="motoristas-ui-page-size">
              <span>Exibir</span>

              <select
                value={limit}
                onChange={limits}
                aria-label="Quantidade de motoristas por página"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>

                {totalItems > 0 && (
                  <option value={totalItems}>
                    Todos ({totalItems})
                  </option>
                )}
              </select>

              <span>por página</span>
            </label>
          </footer>
        </section>
      </div>
    </>
  );


}
export default Cadastro;
